import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["listing", "onSubmit"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import DixuForm from "../DixuForm/DixuForm";
import DixuInput from "../DixuInput/DixuInput";
import DixuModal from "../DixuModal/DixuModal";
import DixuNotification from "../DixuNotification/DixuNotification";
import useIsLoading from "../../hooks/useIsLoading";
import { useTranslation } from "../../i18n";
import React, { useContext } from 'react';
import { getErrorDescription, requestDocumentDownloadLink } from "../../services/ApiService";
import { AppContext } from "../DixuApp/DixuApp";
const DixuRequestFileDownloadModal = _ref => {
  let {
      listing,
      onSubmit
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    t
  } = useTranslation(['common', 'listing']);
  const {
    user
  } = useContext(AppContext);
  const {
    displayName: name,
    emails
  } = user || {};
  const email = emails?.[0]?.value;
  const [form] = DixuForm.useForm();
  const {
    id
  } = listing || {};
  const [submit, isSubmitting] = useIsLoading(async values => {
    try {
      await requestDocumentDownloadLink({
        listingID: id,
        data: values
      });
      DixuNotification.success({
        message: t('listing:DownloadDocuments:DocumentEmailSent')
      });
      form.resetFields();
      onSubmit?.();
    } catch (error) {
      DixuNotification.error({
        message: t('Pyyntö epäonnistui'),
        description: getErrorDescription(error)
      });
    }
  });
  const initialValues = {
    name,
    email
  };
  return /*#__PURE__*/React.createElement(DixuModal, _objectSpread(_objectSpread({}, rest), {}, {
    title: t('listing:DownloadDocuments:Title'),
    width: 582,
    okButtonProps: {
      htmlType: 'submit',
      form: 'request-file-download-link',
      onClick: null
    },
    loading: isSubmitting
  }), /*#__PURE__*/React.createElement(DixuForm, {
    form: form,
    name: "request-file-download-link",
    initialValues: initialValues,
    onFinish: submit
  }, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "name",
    label: t('common:Name'),
    rules: [{
      required: true
    }]
  }, /*#__PURE__*/React.createElement(DixuInput, null)), /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "email",
    label: t('common:Email'),
    rules: [{
      required: true,
      type: 'email'
    }]
  }, /*#__PURE__*/React.createElement(DixuInput, {
    type: "email"
  }))));
};
DixuRequestFileDownloadModal.defaultProps = {};
export default DixuRequestFileDownloadModal;